// Formats the date range header element for an hours table section.
// currentEndDate is exclusive — displayed as one day earlier.
export const formatWeekDateRange = (elementId, currentStartDate, currentEndDate) => {
    const element = document.getElementById(elementId);
    const trueEndDate = new Date(Date.parse(currentEndDate));
    trueEndDate.setDate(trueEndDate.getDate() - 1);
    const month = trueEndDate.getMonth() + 1;
    const day = trueEndDate.getDate();
    const year = trueEndDate.getFullYear();
    element.innerHTML = `${currentStartDate} - ${month}/${day}/${year}`;
};

// Returns the pay/rate for a given date from a historical price object.
// priceArray: object with epoch-ms string keys and numeric values (e.g. { "0": 15, "1710000000000": 18 })
// timestamp: epoch ms to look up
export const determinePriceByDate = (priceArray, timestamp) => {
    const keys = Object.keys(priceArray).sort();
    for (let i = 1; i < keys.length; i++) {
        if (timestamp < keys[i]) {
            return priceArray[keys[i]];
        }
    }
    return priceArray[0];
};

// Calculates scheduled (pre-adjustment) minutes worked from a list of shifts.
// Options:
//   excludeCleaning (default true)  — skip shifts where client === "Cleaning"
//   useOriginalIfEdited (default true) — when a shift has been edited, use
//     originalStartTime/originalEndTime rather than the current start/end.
//     Set false for the client billing view, which always uses start/end.
export const minsInSpan = (shifts, { excludeCleaning = true, useOriginalIfEdited = true } = {}) => {
    let minutesWorked = 0;
    for (const shift of shifts) {
        if (shift.isFlatFee) continue;
        if (excludeCleaning && shift.client === 'Cleaning') continue;
        const start = new Date(useOriginalIfEdited && shift.editedStartTime ? shift.originalStartTime : (shift.editedStartTime || shift.start));
        const end   = new Date(useOriginalIfEdited && shift.editedEndTime   ? shift.originalEndTime   : (shift.editedEndTime   || shift.end));
        minutesWorked += (end.getTime() - start.getTime()) / 1000 / 60;
    }
    return minutesWorked;
};

// Calculates actual (post-adjustment) minutes worked from a list of shifts.
// Uses editedStartTime/editedEndTime when present, otherwise falls back to start/end.
// Options:
//   excludeCleaning (default true) — skip shifts where client === "Cleaning"
export const minsInSpanEdited = (shifts, { excludeCleaning = true } = {}) => {
    let minutesWorked = 0;
    for (const shift of shifts) {
        if (shift.isFlatFee) continue;
        if (excludeCleaning && shift.client === 'Cleaning') continue;
        const start = new Date(shift.editedStartTime || shift.start);
        const end = new Date(shift.editedEndTime || shift.end);
        minutesWorked += (end.getTime() - start.getTime()) / 1000 / 60;
    }
    return minutesWorked;
};

// Converts minutes to a hours string rounded to 2 decimal places.
export const hoursInSpan = (mins) => (mins / 60).toFixed(2);
